import { get } from 'lodash';

export const trimObject = (obj: object) => {
  const trimmedEntries = Object.entries(obj).map(([k, v]) =>
    typeof v === 'string' ? [k, v.trim()] : [k, v],
  );

  return Object.fromEntries(trimmedEntries);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TIndexedObject<T = any> = Record<string, T>;

export const createHashedObject = <
  T extends TIndexedObject,
  Prop extends keyof T,
  ValueArray extends boolean = false,
>(
  array: T[] = [],
  prop: Prop = 'id' as Prop,
  isValueArray?: ValueArray,
  shouldRemoveKeyField?: boolean,
): Record<T[Prop], ValueArray extends true ? T[] : T> => {
  return array.reduce(
    (acc, current) => {
      const key = get(current, prop as string) as unknown as T[Prop];

      if (shouldRemoveKeyField) {
        delete current[prop];
      }

      if (isValueArray) {
        const existingValue = acc[key] as T[] | undefined;
        acc[key] = [
          ...(Array.isArray(existingValue) ? existingValue : []),
          current,
        ] as ValueArray extends true ? T[] : T;
      } else {
        acc[key] = current as ValueArray extends true ? T[] : T;
      }

      return acc;
    },
    {} as Record<T[Prop], ValueArray extends true ? T[] : T>,
  );
};
